export const backends = [
  {
    value: 'http://localhost:8999/api/internal/my-business',
    label: 'localhost',
    countryCode: 'fi',
    env: 'dev',
    disabled: false,
    faqUrl: 'https://support.yeply.nl/hc/nl',
    timezone: 'Europe/Amsterdam',
    hostname: 'localhost',
  },
  {
    value: 'https://business.stag.yeply.fi/api/internal/my-business',
    label: 'Finland staging',
    countryCode: 'fi',
    env: 'staging',
    disabled: false,
    faqUrl: null,
    timezone: 'Europe/Helsinki',
    hostname: 'business.stag.yeply.fi',
  },
  {
    value: 'https://business.yeply.nl/api/internal/my-business',
    label: 'Netherlands',
    countryCode: 'nl',
    env: 'prod',
    disabled: false,
    faqUrl: 'https://support.yeply.nl/hc/nl',
    timezone: 'Europe/Amsterdam',
    hostname: 'business.yeply.nl',
  },
  {
    value: 'https://business.yeply.fi/api/internal/my-business',
    label: 'Finland',
    countryCode: 'fi',
    env: 'prod',
    disabled: false,
    faqUrl: null,
    timezone: 'Europe/Helsinki',
    hostname: 'business.yeply.fi',
  },
  {
    value: 'https://business.yeply.de/api/internal/my-business',
    label: 'Germany',
    countryCode: 'de',
    env: 'prod',
    disabled: false,
    faqUrl: null,
    timezone: 'Europe/Berlin',
    hostname: 'business.yeply.de',
  },
]
